export default "__VITE_ASSET__nWRZEWbJ__"